<div class="innerpage-fullwithbanner">
    <h2 class="bighead">1031 Inquiries <span class="offerstatus">{{rowCount|number}}</span></h2>
    <ul class="bread-crumbs">
        <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
        <li>Opportunity<span style="padding:8px;">|</span></li>
        <li>1031 Inquiries</li>
    </ul>
</div>
<div class="featuredproperties section-margin">
    <div class="container container-lg min-heightcontainer">
        <div class="row">
            <div class="col-lg-12 ">
                <div class="border-div table-fixed margin-bottom-0">
                    <div class="floatinghead clearfix">
                        <div class="row">
                            <div class="form-group margin-bottom-10 col-sm-7">
                                <ul class="statuslisting user-listing margin-bottom-0">
                                    <li class="transition" style="border: 1px solid #d8d0d0;" *ngFor="let item of filterCount;let i=index" [class.active]="activefilterButton === item.ParameterId" (click)="onSortData(item.ParameterId)">
                                        <a href="javascript:void(0);">
                                            <h3 [style.color]="colors[i]">{{item.ParameterCount}}</h3>
                                            <h4 style="color:black">{{item.ParameterName}}</h4>
                                        </a>
                                    </li>
                                    <li class="transition link-btn-li" (click)="onSortData(0)">
                                        <a class="bluelinkunderline" href="javascript:void(0);">View all</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-5">
                                <div class="rightside d-flex clearfix ">
                                    <div class="search-sec">
                                        <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                                        <i class="fa fa-search icon" aria-hidden="true"></i>
                                    </div>
                                    <button class="btn-border btn adduserbtn margin-left-10" (click)="openCreateInquiry(CreateNewInquiry)">Share Link</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                            <thead>
                              <tr>
                                <th class="sticky-left z-100" style="width:80px !important;position:static; cursor:auto;" data-orderable="false">Action</th>
                                <th>Inquiry Date</th>
                                <th class="min-width-td sticky-left z-100">Prospect</th>
                                <th>User Role</th>
                                <th>Sale Price</th>
                                <th>Sale / Projected Sale Date</th>
                                <th>1031 Properties</th>
                                <th>Status</th>
                                <th>Source</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let inquiry of inquiryList;let i = index ">
                                <td class="whitespacenowrap">
                                  <div class="d-flex">
                                  <div class="btn-group rightdropdown mr-5" dropdown *ngIf="inquiry.UserRoleId == Authentication.UserRole.Principal || inquiry.UserRoleId == Authentication.UserRole.Principal1031 || inquiry.UserRoleId == Authentication.UserRole.GuestUser">
                                    <button id="button-basic" dropdownToggle type="button" class="blueone dropdown-toggle"
                                            aria-controls="dropdown-basic" placement="right" tooltip="Action">
                                      <i class="fa fa-cog" aria-hidden="true"></i>
                                    </button>
                                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu z-index-99"
                                        role="menu" aria-labelledby="button-basic">
                                      <li role="menuitem"><a class="dropdown-item" (click)="openCreateExchangeModel(CreateExchange,inquiry.ID);" href="javascript:void(0);">Create Exchange</a></li>
                                    </ul>
                                  </div>
                                  <div class="btn-group">
                                    <a class="blueone" href="javascript:void(0);" routerLink="/exchange1031-view/{{inquiry.ExGuid}}"><i class="icofont icofont-info" aria-hidden="true" placement="right" tooltip="Inquiry details"></i></a>
                                  </div>
                                  <div class="btn-group" *ngIf="!inquiry.IsEBRA_Accepted && !inquiry.IsEBRALinkSent">
                                    <a href="javascript:void(0);" (click)="openConfirmSendLink(inquiry.UserId)" class="remove" tooltip="Send Agreement Link" placement="right">
                                      <i class="fa fa-envelope" aria-hidden="true"></i>
                                    </a>
                                  </div>
                                  <div class="btn-group agreement-link" *ngIf="!inquiry.IsEBRA_Accepted && inquiry.IsEBRALinkSent">
                                    <a href="javascript:void(0);" (click)="openConfirmSendLink(inquiry.UserId)" class="remove" tooltip="{{'Resend Agreement Link. Last Sent on :'+ (inquiry.EBRASendDate | date: 'M/d/yyyy h:mm a') }}" placement="right">
                                      <i class="fa fa-share-square-o" aria-hidden="true"></i>
                                    </a>
                                  </div>
                                  <div class="btn-group" *ngIf="inquiry.IsEBRA_Accepted && inquiry.EBRAPath">
                                    <a class="view" href="{{inquiry.EBRAPath}}" download target="_blank" placement="left" tooltip="Download Agreement" triggers="hover">
                                      <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                                    </a>
                                  </div>
                                </div>
                                </td>
                                <td class="whitespacenowrap">
                                  <div class="d-flex align-item-center agreement-link">
                                    <div class="req-submitted" *ngIf="!inquiry.IsEBRALinkSent && inquiry.Is1031RequestSent" tooltip="Request submitted for 1031 Listings access" placement="right"><i class="fa fa-shield" aria-hidden="true"></i></div>
                                    <p class="whitespacenowrap">{{ Validation.convertUTCDateToLocalDate(inquiry.InquiryDate)| date:'MM/dd/yyyy' }}</p>
                                  </div>
                                </td>
                                <td class="sticky-left">
                                  <p><a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{principal:inquiry.UserGuid, prevroute:'1031 Inquiries', link : '1031-inquiry'}">{{ inquiry.Buyer }}</a></p>
                                  <p class="whitespacenowrap">{{ inquiry.Phone | phone }}</p>
                                  <p class="whitespacenowrap">{{ inquiry.Email }}</p>
                                </td>
                                <td>
                                  <p class="whitespacenowrap">{{ inquiry.UserRole }}</p>
                                </td>
                                <td>
                                  <p>{{ (inquiry.SalePrice!=null&&inquiry.SalePrice>=0) ? '$ ' + (inquiry.SalePrice | number):'-' }}</p>
                                </td>
                                <td>
                                  <p>{{ inquiry.ProjectedSaleDate ? (Validation.convertUTCDateToLocalDate(inquiry.ProjectedSaleDate)| date:'MM/dd/yyyy') :'-' }}</p>
                                </td>
                                <td style="text-align:center">
                                  <label class="custom-checkbox withoutlabel">
                                    <input type="checkbox" [(ngModel)]="inquiry.AccessTo1031" (change)="grant1031Access(inquiry.UserGuid,$event)" class="ng-pristine ng-valid ng-touched"><i></i>
                                  </label>
                                </td>
                                <td>
                                  <label class="select">
                                    <select class="form-control" id="status" #status [(ngModel)]="inquiry.InquiryStatusId" (change)="changeInquiryStatus(inquiry.InquiryStatusId,inquiry.ID)">
                                      <option *ngFor="let stype of statusList" [(ngValue)]="stype.id">{{stype.description}}</option>
                                    </select>
                                    <i></i>
                                  </label>
                                </td>
                                <td>
                                  <p>{{ inquiry.InquirySource ?  inquiry.InquirySource :'-' }}</p>
                                </td>

                              </tr>
                            </tbody>
                            <tfoot>
                                <tr *ngIf="inquiryList?.length == 0 &&!IsLoading">
                                    <td colspan="8" class="odd no-data-available">
                                        <div class="nodata">
                                            <i class="fa fa-exclamation-triangle icon"></i>
                                            <p>No Data Available</p>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #CreateExchange class="pull-left">
    <div class="modal-header">
        <h4 class="modal-title pull-left">
            Create New Exchange
        </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label class="form-label">Exchange ID</label>
            <input class="form-control" [(ngModel)]="exchange.Id" maxlength="100" required type="text" disabled>
        </div>
        <div class="form-group">
            <label class="form-label">Principal</label>
            <input class="form-control" [(ngModel)]="exchange.Principal" maxlength="100" required type="text" disabled>
        </div>
        <div class="form-group">
            <label class="form-label">Sale Price</label>
            <div class="textbox-with-btn-left">
                <input class="form-control" formControlName="txttotalsaleprice" id="SalePrice" [dropSpecialCharacters]="false" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"  [(ngModel)]="exchange.SalePrice" value="{{exchange.SalePrice|number}}" maxlength="18" disabled><span class="leftlabel">$</span>
            </div>
        </div>
        <div class="form-group">
            <label class="form-label">Sale/Projected Sale Date</label>
            <div class="textbox-date">
                <input bsDatepicker class="form-control" #SaleDate="ngModel" [(ngModel)]="exchange.SaleDate" type="text" disabled>
                <i class="icofont icofont-ui-calendar icon"></i>
            </div>

        </div>
        <div class="form-group">
            <label class="form-label">Broker</label>
            <div class="select-dropdown  multiselectdesign select-check">
              <!--<angular2-multiselect [data]="brokers" [(ngModel)]="brokersSelected" [settings]="defaultBrokerSettings" #broker></angular2-multiselect>-->
              <mat-form-field>
                <mat-select (click)="addClassToOverlayContainer()" [(ngModel)]="brokersSelected" multiple placeholder="Select Brokers">
                  @if (brokersSelected.length > 1) {
                    <mat-select-trigger>
                      <span>{{ brokersSelected.length }} items selected</span>
                    </mat-select-trigger>
                  }
                  @for (broker of brokers; track broker) {
                    <mat-option class="multi-dropdown-item no-border" [value]="broker.id">{{broker.name}}</mat-option>
                  }
                  <mat-option class="matoptionnodata" *ngIf="brokers?.length === 0" disabled>
                    Nothing found...
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
        </div>
        <div class="text-right">
            <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>
            <button class="btn btn-success btn-lg" [disabled]="hideAssignbtn" (click)="saveBroker(template);">Create Exchange</button>
        </div>
    </div>

</ng-template>

<ng-template #CreateNewInquiry class="pull-left">
    <div class="modal-header">
        <h4 class="modal-title pull-left">
            Share Link
        </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefInquiry.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label class="form-label">First Name<span class="star">*</span></label>
            <input class="form-control" [(ngModel)]="exchangeInputModel.firstname" #FirstName="ngModel" type="text" maxlength="50">
            <p class="redtext" *ngIf="(Validation.IsinValid(exchangeInputModel.firstname) && isSubmitInquiry) ||(FirstName.invalid && FirstName.touched)">First Name is required </p>
        </div>
        <div class="form-group">
            <label class="form-label">Last Name<span class="star">*</span></label>
            <input class="form-control" [(ngModel)]="exchangeInputModel.lastname" #lastname="ngModel" type="text" maxlength="50">
            <p class="redtext" *ngIf="(Validation.IsinValid(exchangeInputModel.lastname) && isSubmitInquiry) ||(lastname.invalid && lastname.touched)">Last Name is required </p>
        </div>
        <div class="form-group">
            <label class="form-label">Email Address<span class="star">*</span></label>
            <input class="form-control" [(ngModel)]="exchangeInputModel.email" #email="ngModel" type="text" maxlength="50">
            <p class="redtext" *ngIf="(Validation.IsinValid(exchangeInputModel.email) && isSubmitInquiry) ||(email.invalid && email.touched)">Email Address is required </p>
            <p class="redtext" *ngIf="(!Validation.IsinValid(exchangeInputModel.email) && !Validation.isEmail(exchangeInputModel.email) && isSubmitInquiry)">Invalid Email Address </p>
        </div>
        <div class="form-group">
            <label class="form-label">Message</label>
            <textarea class="form-control property-description" [(ngModel)]="exchangeInputModel.Message" maxlength="2000" rows="4"></textarea>
        </div>
        <div class="text-right">
            <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRefInquiry.hide();">Cancel</button>
            <button class="btn btn-success btn-lg" (click)="submitInquiry();">Send</button>
        </div>
    </div>
</ng-template>

<ng-template #Confirmation>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Are you sure, you want to send the "1031 Trade Participation Agreement" link to </h6>
            <h6 class="displayvalue">{{sendToUserLink}} ? </h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRefConfirmation.hide();">Cancel</button>
            <button class="btn btn-lg btn-success" (click)="SendLinkToEBRA()">Send</button>
        </div>
    </div>
</ng-template>
